import { useEffect, useState } from 'react';
import First from 'components/main/First';
import Second from 'components/main/Second';
import PageTemplate from 'components/template/PageTemplate';
import Third from 'components/main/Third';
import Fifth from 'components/main/Fifth';
import { jsonAxios } from 'components/axios';
import { useGetUser, userAtom } from 'atom/user';
import { useSetAtom } from 'jotai';
import { encrypt } from 'components/encryptDecrpt';
import FloatingArea from 'components/main/FloatingArea';
import TransportTracking from 'components/common/modal/TransportTracking';
import Fourth from 'components/main/Fourth';
import Seventh from 'components/main/Seventh';
import Eighth from 'components/main/Eighth';
import Sixth from 'components/main/Sixth';
import MainQuoteLoginPop from 'components/common/modal/MainQuoteLoginPop';
import { IInfo } from 'types/quote';
import NoticeModal from 'components/common/modal/NoticeModal';
import { getToday } from 'components/function';

const Main = () => {
    const user = useGetUser();
    const setUser = useSetAtom(userAtom)
    const [blNo, setBlNo] = useState<string>('');
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isNoticeOpen, setIsNoticeOpen] = useState<boolean>(false)
    const [loginQuote, setLoginQuote] = useState<boolean>(false)
    const [info, setInfo] = useState<IInfo>({
        transportType: 'SEA',
        shipmentMode: 'FCL',
    } as IInfo)

    useEffect(() => {
        getUser();
    }, [])

    useEffect(() => {
        const savedDate = localStorage.getItem('isNotice');
        const today = getToday();

        if (savedDate === today) {
            setIsNoticeOpen(false);
        }
        else {
            setIsNoticeOpen(true);
        }
    }, []);

    const getUser = () => {
        if (!user.id) return
        jsonAxios.get('user/info').then(res => {
            if (res.data.code === 200) {
                setUser(encrypt(JSON.stringify(res.data.data)))
            }
        })
    }

    return (
        <PageTemplate overLay={false}>
            {/* 메인 */}
            <div className='relative mainSlide'>
                <First />
                <FloatingArea
                    blNo={blNo}
                    setBlNo={setBlNo}
                    setIsOpen={setIsOpen}
                    setLoginQuote={setLoginQuote}
                    info={info}
                    setInfo={setInfo}
                />
            </div>
            {/* 스마트 */}
            <Second />
            {/* 배너 */}
            <Third />
            <div className='flex flex-col gap-[180px] py-[180px]'>
                {/* 특가 */}
                {
                    user?.id &&
                    user?.isVIP &&
                    <Fourth />
                }
                {/* 뉴스 */}
                <Fifth />
            </div>

            {/* 솔로몬쉽 배너 */}
            <Sixth />
            {/* 수출입 준비 */}
            <Seventh />
            {/* 디지털 토탈 물류 솔로션 배너 */}
            <Eighth />
            <TransportTracking
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                info={{
                    type: 'SEA',
                    bookingNumber: '',
                    blNo: blNo,
                    carrierName: ''
                }}
            />

            <NoticeModal
                isOpen={isNoticeOpen}
                setIsOpen={setIsNoticeOpen}
            />

            <MainQuoteLoginPop
                isOpen={loginQuote}
                setIsOpen={setLoginQuote}
                info={info}
            />
        </PageTemplate>
    );
}

export default Main;